import Vue from 'vue';
import '@babel/polyfill';
import './components/cube-ui';
import './components/ydui';
import './components/elui';
import App from './App.vue';
import router from './router/index.js';
import store from './store/index.js';
import './helper/index';
import mixins from './mixins/index';
// import toast from './helper/toast';
import './utils/helper';
import './utils/flexible';
import VueHead from 'vue-head';
// import './helper/vconsole';
// import 'amfe-flexible';
// import querySysInfo from './utils/querySysInfo';
import Vant from 'vant';
import 'vant/lib/index.css';
import LazyCollapse from './components/lazy-collapse.vue';

Vue.use(Vant);
Vue.use(mixins);
Vue.use(VueHead, {
    separator: '',
    complement: ''
});

Vue.component('LazyCollapse', LazyCollapse);

// eslint-disable-next-line
router.afterEach((to, from) => {
    store.commit('updateHeadDOM', {
        title: to.meta.title || '',
        description: to.meta.title || '',
        keywords: to.meta.title || ''
    });
    // toast.clear(800);
    // next();
});
Vue.config.productionTip = false;

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
